import { render, staticRenderFns } from "./ItemBar.vue?vue&type=template&id=4f0b3200&scoped=true&"
import script from "./ItemBar.vue?vue&type=script&lang=js&"
export * from "./ItemBar.vue?vue&type=script&lang=js&"
import style0 from "./ItemBar.vue?vue&type=style&index=0&id=4f0b3200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0b3200",
  null
  
)

export default component.exports